import { ElementType } from "@easy-email-pro-core/constants";
import {
  ElementChildren,
  HTMLDomNodeElement,
} from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type HtmlDomNodeProps = RecursivePartial<
  HTMLDomNodeElement["attributes"]
> & {
  idx?: string | null;
  children?: ElementChildren | HTMLDomNodeElement["children"];
  tagName: HTMLDomNodeElement["data"]["tagName"];
};

export function HtmlDomNode(props: HtmlDomNodeProps) {
  const { tagName, idx, children: propsChildren, ...rest } = props;

  const node: HTMLDomNodeElement = {
    type: ElementType.HTML_DOM_NODE,
    data: { tagName },
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
